<template>
  <div>
    <!-- <v-professionals></v-professionals> -->
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-progress-linear v-bind:indeterminate="true" v-show="loadingOk === false"></v-progress-linear>
      </v-layout>

      <v-flex xs12 sm12 md12 lg12>
        <div class="text-xs-center" style="height: 30px; position: relative; margin-top: 30px;">
          <v-btn
            v-show="this.allowedDates.length > 0"
            :disabled="loadingOk === false"
            round :color="this.getTheme.color"
            :dark="loadingOk === true"
            @click="clearloadingData()">
            <v-icon>search</v-icon> refazer  busca
          </v-btn>
          <v-chip
            v-show="this.allowedDates.length > 0"
            v-if="getDevice.isMobile"
            dark
            class="ma-2"
            :color="this.getTheme.color"
            text-color="white"
          >
          <v-avatar left>
          <v-icon>save_alt</v-icon>
          </v-avatar>
            Role para baixo
          </v-chip>
        </div>
        <v-card div v-show="this.allowedDates.length === 0">
          <v-card-text >
            <v-select
              item-text="name"
              item-value="id"
              label="Convênio"
              v-model="healthInsurance"
              :items="healthInsurances"
              :rules="[v => !!v || 'Você deve informar o convênio!']" required
              :disabled="this.customer === '5ab94676e9fb5d49ae9bc641'"
            >
            </v-select>

            <v-select
              item-text="name"
              item-value="id"
              label="Especialidade"
              v-model="specialist"
              :items="specialists"
              :rules="[v => !!v || 'Você deve informar a especialidade!']"
              required
              :disabled="!this.healthInsurances.length"
            >
            </v-select>

            <v-select
              item-text="name"
              item-value="id"
              label="Selecione um ou mais profissionais de sua preferência ou deixe em branco para todos"
              multiple
              chips
              :items="professionals"
              v-model="professional"
              :disabled="!this.specialist"
            ></v-select>
            <!-- Funcionando -->
            <!-- <v-select
              v-show="!getDevice.isMobile"
              item-text="name"
              item-value="id"
              label="Selecione um ou mais profissionais de sua preferência ou deixe em branco para todos"
              multiple
              autocomplete
              chips
              :items="professionals"
              v-model="professional"
              :disabled="!this.specialist"
            ></v-select> -->

          </v-card-text>
          <v-card-text style="height: 30px; position: relative">
            <!-- <v-btn
              absolute
              dark
              fab
              top
              right
              color = 'primary'
              @click="loadingData()"
            >
              <v-icon>search</v-icon>
            </v-btn> -->
          </v-card-text>
        </v-card>
      </v-flex>
      <br>
      <v-flex xs12 sm12 md12 lg12 v-if="this.allowedDates.length === 0">
        <v-icon>event</v-icon>
        <span>Período de dias para sua consulta</span>
        <vue-slider
          class="vue-slider"
          v-bind="period"
          v-model="period.value"
        ></vue-slider>
      </v-flex>
      <v-flex v-show="this.allowedDates.length === 0">
        <div class="text-xs-center" style="height: 30px; position: relative; margin-top: 30px;">
          <v-btn
            :disabled="loadingOk === false"
            round :color="this.getTheme.color"
            :dark="loadingOk === true"
            @click="loadingData()">
            <v-icon>search</v-icon> Buscar Horários
          </v-btn>
        </div>
      </v-flex>
      <br><br>
      <v-flex>
        <div v-if="(this.allowedDates.length) > 0">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card>
                <v-card-text>
                  <v-date-picker
                      class="mt-0"
                      v-model="date"
                      locale="pt-br"
                      :allowed-dates="allowedDates"
                      :landscape="!getDevice.isMobile"
                      :color="this.getTheme.color"
                      full-width
                  ></v-date-picker>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 md6>
              <v-card>
                <v-card-actions>
                  <v-flex xs10 offset-xs1>
                    <div v-if="nameDoctorsFilters">
                      <v-card color="grey lighten-2">
                        <v-card-text><h3 class="text-xs-center">{{nameDoctorsFilters[countIndexArray].name}}</h3></v-card-text>
                      </v-card>
                        <v-btn
                          absolute
                          dark
                          small
                          fab
                          right
                          :color="this.getTheme.color"
                          style="margin-top: -50px; margin-right: 13px;"
                          @click="addDoctor()"
                        >
                          <v-icon>keyboard_arrow_right</v-icon>
                        </v-btn>
                        <v-btn
                          absolute
                          dark
                          small
                          fab
                          left
                          :color="this.getTheme.color"
                          style="margin-top: -50px; margin-left: 11px;"
                          @click="remDoctor()"
                        >
                          <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                    </div>
                    <div v-else>
                      <v-card>
                        <v-card-media
                          class="white--text"
                          height="170px"
                          src="https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg"
                        >
                          <v-container fill-height fluid>
                            <v-layout fill-height>
                              <v-flex xs12 align-end flexbox>
                                <!-- <span class="headline">Top 10 Australian beaches</span> -->
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-media>
                        <v-card-title>
                          <div>
                            <span class="blue-grey--text">Clique nas datas,</span><br>
                            <span class="blue-grey--text">para informar os horários disponiveis</span>
                          </div>
                        </v-card-title>
                        <v-card-actions>
                          <!-- <v-btn flat color="orange">Share</v-btn>
                          <v-btn flat color="orange">Explore</v-btn> -->
                        </v-card-actions>
                      </v-card>
                    </div>
                  </v-flex>
                </v-card-actions>
                <v-container fluid >
                  <v-layout row wrap>
                    <div v-for="o in this.availableAppointment">
                      <v-chip color="light-blue lighten-1" text-color="white" @click.native.stop="dialog = true" @click="getHour(o)" >{{o.tbHora.substr(0, 5)}}</v-chip>
                    </div>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>

          </v-layout>
        </div>
      </v-flex>

      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-media
            class="white--text"
            height="200px"
            src="https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg"
          >
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <!-- <span class="headline">Top 10 Australian beaches</span> -->
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-media>
          <v-card-title>
            <div
              style="width: 100%"
            >
              <!-- <span class="grey--text">Number 10</span><br> -->
              <span class="blue-grey--text headline">Sua consulta será com</span><br>
              <span class="blue-grey--text subheading"><b>{{getAvailableAppointments.tbNomeMedico}},</b></span><br>
              <span class="blue-grey--text subheading">no dia <b>{{getAvailableAppointments.tbData}}</b>, às <b>{{getAvailableAppointments.hour}}</b> horas.</span>
                <v-text-field
                  v-model="obs"
                  item-text="obs"
                  item-value="obs"
                  :items="obs"
                  label="Observação"
                  full-width
                  counter="35"
                  maxlength="35"
                  style="height=500px;"
                  Observação
                >{{getAvailableAppointments.obs}}
                </v-text-field>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              color = 'primary'
              block
              @click.native="dialog = false"
              @click="scheduleAppointment()"
            >
              Agendar
            </v-btn>
            <v-btn flat color="secondary" @click.native="dialog = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSchedule" persistent max-width="600">
        <v-card>
          <v-card-media
            class="white--text"
            height="200px"
            src="https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg"
          >
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <!-- <span class="display-1 red--text">Você possui agendamentos nos próximos 30 dias</span> -->
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-media>
          <v-card-title>
            <div>
              <v-list two-line>
                <template v-for="item in items">
                  <v-subheader v-bind:key="item.id" v-if="items.title" v-text="items.title"></v-subheader>
                  <v-divider v-bind:key="item.id" v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
                  <v-list-tile avatar v-bind:key="item.hour_schedule">
                    <v-list-tile-avatar>
                      <v-icon>event</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.doctor"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.date_schedule"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-html="item.hour_schedule"></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <!-- <v-list-tile-action>
                      <v-btn icon ripple @click.stop="dialogCancel = true" @click.prevent="data(item)">
                        <v-icon color="grey lighten-1">block</v-icon>
                      </v-btn>
                    </v-list-tile-action> -->
                  </v-list-tile>
                </template>
              </v-list>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              color = 'primary'
              block
              @click=""
            >
              FAVOR ENTRAR EM CONTATO
            </v-btn>
            <router-link to="/patient/history">
              <v-btn flat color="secondary" @click.native="dialogSchedule = false">Cancelar agendamentos online</v-btn>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>

    <v-snackbar
      :timeout="snackbarConfig.timeout"
      :color="snackbarConfig.color"
      :multi-line="snackbarConfig.mode === 'multi-line'"
      :vertical="snackbarConfig.mode === 'vertical'"
      v-model="snackbarConfig.snackbar"
    >
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import vueSlider from 'vue-slider-component'
import VProfessionals from '@/components/Professionals'
import { mapGetters, mapActions } from 'vuex'
// import { url } from '../../../config/api.link.connection'
moment.locale('pt-br')

export default {
  name: 'Schedule',
  components: {
    VProfessionals,
    vueSlider
  },
  computed: {
    ...mapGetters({
      customer: 'customer',
      auth: 'auth'
    }),
    ...mapGetters('schedule', ['getList', 'getAvailableAppointments']),
    ...mapGetters('app', ['getTheme', 'getDevice'])
  },
  watch: {
    specialist (newVal, oldVal) {
      if (newVal !== undefined) {
        this.loadingProfessionals()
      }
    },
    professional (newVal, oldVal) {
    },
    // Carrega quando muda a tag HTML ??
    // select (newVal, oldVal) {
    //   this.loadingDates(newVal)
    // },
    date (newVal, oldVal) {
      this.countIndexArray = 0
      this.dateExtension = moment(newVal).format('LL')
      const arrayDates = _.filter(this.getList, (o) => {
        return moment(o.tbData, 'DD/MM/YYYY').format('YYYY-MM-DD') === newVal
      })
      this.arrayDatesAll = arrayDates
      const arrayDoctors = []

      _.filter(arrayDates, (o) => {
        this.professionals.map((item) => {
          if (o.tbMedico === item.id) {
            arrayDoctors.push({id: o.tbMedico, name: item.name, date: o.tbData, hour: o.tbHora.substr(0, 5)})
          }
        })
      })

      const nameDoctors = arrayDoctors.map(item => {
        return {
          id: item.id,
          name: item.name
        }
      })
      const uniqueArray = _.uniqBy(nameDoctors, (o) => {
        return o.name
      })
      this.nameDoctorsFilters = uniqueArray
      this.availableAppointments(this.arrayDatesAll, uniqueArray[0].id)
    },
    healthInsurance (newVal, oldVal) {
      this.loadingSpecialist()
      this.loadingProfessionals()
    }
  },
  methods: {
    ...mapActions('schedule', ['setList', 'setAvailableAppointments']),
    scheduleAppointment () {
      this.getAvailableAppointments.obs = this.obs ? `Obs. Paciente: ${this.obs}` : null
      this.$http.post(process.env.URL + '/schedule-online/schedule-sync/schedule-appointment', {
        data: this.getAvailableAppointments
      }, {
        params: {
          customer: this.customer,
          token: this.auth.token
        }
      }).then((response) => {
        this.$router.push('/patient/history')
      }).catch((err) => {
        if (this.data === undefined || this.data === {}) {
          return console.error('Falha na comunicação com o servidor')
        }
        console.error(err)
        this.snackbarConfig.snackbar = true
        this.snackbarConfig.text = err.response.data.result.error
      })
    },
    getHour (hour) {
      hour.hour = hour.tbHora.substr(0, 5)
      hour.tbNomeMedico = this.nameDoctorsFilters[this.countIndexArray].name
      hour.idUser = this.auth.user.id
      hour.client_email = this.auth.user.username
      hour.client_name = this.auth.user.name
      hour.health_insurance = this.healthInsurance // this.auth.user.healthInsurance
      hour.numberMedicalRecord = this.auth.user.numberMedicalRecord
      hour.client_phone_number = this.auth.user.profile.phone
      hour.client_mobile_number = this.auth.user.profile.mobile
      this.setAvailableAppointments(hour)
    },
    availableAppointments (arrayDates, doctor) {
      const arrayDoctorsAll = _.filter(arrayDates, (o) => {
        return o.tbMedico === doctor
      })
      this.availableAppointment = arrayDoctorsAll
    },
    addDoctor () {
      if ((this.countIndexArray + 1) < this.nameDoctorsFilters.length) {
        this.countIndexArray++
        this.availableAppointments(this.arrayDatesAll, this.nameDoctorsFilters[this.countIndexArray].id)
      }
    },
    remDoctor () {
      if (this.countIndexArray > 0) {
        this.countIndexArray--
        this.availableAppointments(this.arrayDatesAll, this.nameDoctorsFilters[this.countIndexArray].id)
      }
    },
    unique (value, index, self) {
      return self.indexOf(value) === index
    },
    loadHealthInsurance () {
      this.$http.get(process.env.URL + '/schedule-online/health-insurance', {
        params: {
          customer: this.customer
        }
      }).then((healthInsurance) => {
        this.healthInsurances = healthInsurance.data.result
        this.healthInsurance = this.auth.user.healthInsurance
      }).catch((err) => {
        console.error(err)
      })
    },
    loadingSpecialist () {
      this.$http.get(process.env.URL + '/doctors/specialist/', {
        params: {
          customer: this.customer,
          healthInsurance: this.healthInsurance || this.auth.user.healthInsurance,
          birthDay: null || this.auth.user.profile.birthDay
        }
      }).then((specialist) => {
        if ((specialist.data.result === undefined) || (specialist.data.result === null)) {
          this.specialists = []
        } else {
          this.specialists = specialist.data.result
          /** Codigo abaixo colocado após pedido da iguaçu - 05/04/2018 */
          if (specialist.data.result.length === 1) {
            const uniqueSpecialist = specialist.data.result.map(item => item.id)
            this.specialist = uniqueSpecialist[0]
          } else {
            this.specialist = null
          }
          /** ********************************************************** */
        }
      }).catch((err) => {
        console.error(err)
      })
    },
    loadingProfessionals () {
      this.$http.get(process.env.URL + '/doctors/', {
        params: {
          customer: this.customer,
          healthInsurance: this.healthInsurance || this.auth.user.healthInsurance,
          specialist: this.specialist,
          birthDay: null || this.auth.user.profile.birthDay
        }
      }).then((professionals) => {
        if ((professionals.data.result === undefined) || (professionals.data.result === null)) {
          this.professionals = []
        } else {
          this.professionals = professionals.data.result
          this.professional = []
          this.setList({})
          this.allowedDates = []

          // this.nameDoctorsFilters = null
          // this.availableAppointment = []
        }
        // this.loadingDates()
      }).catch((err) => {
        console.error(err)
      })
    },
    loadingBilling () {
      this.$http.get(process.env.URL + '/schedule-online/billing', {
        params: {
          customer: this.customer,
          record: this.auth.user.numberMedicalRecord
        }
      }).then((result) => {
        if (result.data.result.length > 0) {
          this.dialogSchedule = true
        }
        this.items = result.data.result.map((item) => {
          item.divider = true
          item.inset = true
          item.header = 'Você teve um faturamento nos ultimos 30 dias'
          return item
        })
        this.items.title = 'Você teve um faturamento nos ultimos 30 dias'
      }).catch((err) => {
        console.error(err)
      })
    },
    loadingSchedule () {
      this.$http.get(process.env.URL + '/schedule-online/schedule-sync/scheduled-appointments', {
        params: {
          customer: this.customer,
          record: this.auth.user.numberMedicalRecord
        }
      }).then((result) => {
        if (result.data.results.results.length > 0) {
          this.dialogSchedule = true
        }
        this.items = result.data.results.results.map((item) => {
          item.divider = true
          item.inset = true
          item.header = 'Você possui agendamentos nos próximos 30 dias'
          return item
        })
      }).catch((err) => {
        console.error(err)
      })
    },
    clearloadingData () {
      this.allowedDates = []
      this.availableAppointment = []
    },
    loadingData () {
      if (!this.specialist) {
        this.snackbarConfig.snackbar = true
        this.snackbarConfig.color = 'warning'
        this.snackbarConfig.text = 'Informe uma especialidade!'
        return false
      }

      const qs = require('qs')
      // const firstDay = moment().format('MM-DD-YYYY')
      // const lastFifteenDays = moment().add(this.period.value || 7, 'day').format('MM-DD-YYYY')
      this.loadingOk = false
      this.nameDoctorsFilters = null
      this.allowedDates = []
      this.availableAppointment = []

      this.$http.get(process.env.URL + '/schedule-online/schedule-sync/available-appointments', {
        params: {
          healthInsurance: this.healthInsurance,
          specialist: this.specialist,
          crm: this.professional,
          customer: this.customer,
          initial_datetime: moment().format('MM-DD-YYYY'),
          end_datetime: moment().add(this.period.value || 7, 'day').format('MM-DD-YYYY'),
          birthDay: this.auth.user.profile.birthDay
        },
        'paramsSerializer': (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'})
        }
      }).then((response) => {
        const obj = response.data.parameters
        this.setList(obj)
        const item = obj.map(item => moment(item.tbData, 'DD/MM/YYYY').format('YYYY-MM-DD'))
        const uniqueArray = item.filter(this.unique)
        this.allowedDates = uniqueArray
        this.loadingOk = true
      }).catch((err) => {
        console.error(err)
      })
    }
  },
  data: () => ({
    snackbarConfig: {
      snackbar: false,
      color: 'error',
      mode: '',
      timeout: 6000,
      text: 'Erro de conexão com o servidor!'
    },
    period: {
      value: 3,
      interval: 3,
      min: 3,
      max: 30,
      width: '97%',
      tooltip: 'hover',
      disabled: false,
      piecewise: true,
      piecewiseLabel: true,
      bgStyle: {
        'backgroundColor': '#fff',
        'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
      },
      tooltipStyle: {
        'backgroundColor': '#666',
        'borderColor': '#666'
      },
      processStyle: {
        'backgroundColor': '#999'
      }
    },
    dialog: false,
    dialogSchedule: false,
    arrayDatesAll: null,
    nameDoctorsFilters: null,
    countIndexArray: 0,
    doctors: [],
    healthInsurances: [],
    specialists: [],
    professionals: [],
    doctor: null,
    healthInsurance: null,
    specialist: null,
    professional: null,
    date: null,
    dateExtension: '',
    allowedDates: [],
    lastFiveDays: {
      min: null,
      max: null
    },
    loadingOk: true,
    availableAppointment: [],
    items: [],
    obs: null
  }),
  props: {
    source: String
  },
  mounted () {
    this.allowedDates = []
    this.loadHealthInsurance()
    this.loadingSpecialist()
    // this.loadingBilling()
    if ((this.customer === '5b0d63a420fbbb0f70e77c26') || (this.customer === '5d137731c35f0e6e45ab549e' || (this.customer === '5e503a56462560492f99a1e1'))) {
      this.loadingSchedule()
      this.loadingBilling()
      this.period.max = 21
    } else {
      this.period.max = this.period.max
    }
    // const date = new Date()
    // const d = new Date()
    // d.setDate(date.getDate() - 5)
    // this.lastFiveDays.min = d.toISOString().substr(0, 10)
    // this.lastFiveDays.max = date.toISOString().substr(0, 10)
    // console.log(d.toISOString().substr(0, 10))
    // this.allowedDates = this.everyOtherDay
    // this.allowedDates = ["2017-12-26", "2017-12-04"]
    // console.log(this.allowedDates)
  }
}
</script>

<style scoped>
  .vue-slider {
    margin: 20px 0px 0px 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/schedule/Schedule.vue